import { QueryObserverResult, useQuery } from '@tanstack/react-query';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { GetAuditRequestsRequest, GetAuditRequestsResponse } from '../fragments';
import { getAuditRequests } from '../methods';
import { API_QUERY_KEYS } from '../../constants';
import { CallDirection } from '../../../types';
import { UseTrafficMonitorState } from '../../../store';

export const useAuditRequests = (
  direction: CallDirection
): QueryObserverResult<GetAuditRequestsResponse> => {
  const { requestState, pageNumberState, resultsDataState, paginationState } =
    UseTrafficMonitorState(direction);
  const setPageNumberState = useSetRecoilState(pageNumberState);
  const setData = useSetRecoilState(resultsDataState);
  const setPagination = useSetRecoilState(paginationState);
  const stateValue = useRecoilValue(requestState);
  const request = { ...stateValue, direction } as unknown as GetAuditRequestsRequest;
  return useQuery(
    [API_QUERY_KEYS.getAuditRequests, request],
    () => getAuditRequests(request),
    {
      staleTime: 2000,
      onSuccess: (data: GetAuditRequestsResponse) => {
        if (data?.paginationInfo?.totalCount > 0 && data?.auditRequests.items.length === 0) {
          setPageNumberState(1);
        }
        setData(data?.auditRequests?.items ?? []);
        setPagination(data?.paginationInfo);
      },
    }
  );
};
